import { UpdateType } from '@components/Cart/_SingleLineItem';
import LoadingLogo from '@components/Loading/LoadingLogo';
import Stepper from '@components/Stepper';
import { LineItem } from '@repo/ui/src/types/lineItem';
import React from 'react';

export interface QuantityProps {
  lineItem: LineItem;
  editable?: boolean;
  isLoading: boolean;
  handleChange: (quantity: number, type: UpdateType) => void;
  outOfStock?: boolean;
}

const Quantity = ({
  lineItem,
  editable = false,
  isLoading,
  outOfStock = false,
  handleChange,
}: QuantityProps) => {
  if (lineItem.bonus || (!editable && lineItem.quantity <= 1)) {
    return null;
  }

  if (!editable) {
    return (
      <p
        className="tra-text-web-body-s tw-text-neutral-400 tw-font-bold"
        data-testid="quantity-label"
      >
        Qty: {lineItem.quantity}
      </p>
    );
  }

  return isLoading ? (
    <LoadingLogo className="tw-w-20 tw-pt-4" />
  ) : (
    <Stepper
      quantity={isLoading ? lineItem.quantity : lineItem.quantity}
      handleChange={(quantity) => handleChange(quantity, 'stepper')}
      max={outOfStock ? 0 : 20}
      min={1}
      className="tw-mt-2"
    />
  );
};

export default Quantity;
